import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FloatingButton } from '../styles/WhatsAppButtonStyles';
import { useWhatsAppButton } from '../utils/WhatsAppButtonUtils';

const WhatsAppButtonComp = () => {
  const { whatsappUrl } = useWhatsAppButton();

  return (
    <FloatingButton href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp">
      <FaWhatsapp />
    </FloatingButton>
  );
};

export default WhatsAppButtonComp;
